import Link from 'next/link';
import { useRouter } from 'next/router';
import { Badge, Text } from '@pairy/pds-react';

import useInquirySummary from '@/hooks/queries/client/useInquirySummary';

import * as Styled from './index.styles';

const NAVIGATION_NAMES = {
  Pdf: {
    name: 'PDF',
    route: '/user/pdf',
    className: 'pdf-menu',
  },
  Link: {
    name: '링크',
    route: '/user/link',
    className: 'link-menu',
  },
  Campaign: {
    name: '캠페인',
    route: '/user/campaign',
    className: 'campaign-menu',
  },
  Client: {
    name: '고객',
    route: '/user/client',
    className: 'client-menu',
  },
} as const;

const Navigation = () => {
  const router = useRouter();

  const { data: unreadInquiryCount } = useInquirySummary({
    staleTime: 30_000,
    select: (data) => data.data.data.unreadInquiryCount,
  });

  return (
    <nav>
      <Styled.Ul>
        {Object.values(NAVIGATION_NAMES).map(({ name, route, className }) => (
          <li key={name} className={className}>
            <Link href={route}>
              <Styled.A
                data-state={
                  router.pathname.includes(route) ? 'active' : 'inactive'
                }
              >
                <Text variant="lg-semibold" color="inherit">
                  {name}
                </Text>
                {className === 'client-menu' &&
                  unreadInquiryCount != null &&
                  unreadInquiryCount > 0 && (
                    <Badge
                      backgroundColor="vermillion_400"
                      color="white"
                      paddingX={6}
                      paddingY={2}
                      title={`새로운 리드 ${unreadInquiryCount}건`}
                    >
                      <Text variant="sm-semibold" color="inherit">
                        {unreadInquiryCount > 99 ? '99+' : unreadInquiryCount}
                      </Text>
                    </Badge>
                  )}
              </Styled.A>
            </Link>
          </li>
        ))}
      </Styled.Ul>
    </nav>
  );
};

export default Navigation;
